import React from "react"
import tw, { css, styled } from "twin.macro"

export interface enrolDetailItem {
  title?: string
  text: string[]
}

interface Props {
  items: enrolDetailItem[]
}

const Button = styled.button`
padding: 6px 12.5px; background-color: #0063A6;
font-family: Interstate;
${tw`rounded text-lg text-white tracking-wide uppercase hidden md:inline focus:outline-none`}
`

const enrolDetail: React.FC<Props> = ({ 
  items,
}) => {
  return (
    <ItemsWrapper>
      {items.map((item, index) => (
        <Item key={index}>
          {/* Title if we have one */}
          {!!item.title && <Heading>{item.title}</Heading>}
          {/* Render each text item to a paragraph */}
          {item.text.map((paragraph, index) => <Paragraph key={index} dangerouslySetInnerHTML={{__html: paragraph}} />)}

          <Button
            css={[
            css`@media (max-width: 768px) {
              display: block;
              margin: auto;
            }`,
              tw`transition-opacity duration-500 hidden md:inline`,
            ]}
            onClick={() => window.open('https://www.mito.org.nz/learner-pre-enrolment/' + location.search)}
          >
            Enrol now
          </Button>
        </Item>
      ))}
    </ItemsWrapper>
  )
}

const ItemsWrapper = styled.div`
  ${tw`flex flex-wrap flex-row md:px-24 md:py-6  text-black`}
`

const Item = styled.div`
  ${css`max-width: 26rem`},
  ${tw`w-full text-sm text-center`}
`

const Heading = styled.h1`
  ${tw`font-bold text-3xl mb-6`}
`

const Paragraph = styled.p`
  ${tw`mb-6`}
`

export default enrolDetail
